export default function () {
  return [
    {
      title: "Les Demandes non vérifiées",
      to: "/nonverified",
      htmlBefore: '<i class="material-icons">description</i>',
      htmlAfter: "",
    },
    {
      title: "Les Demandes vérifiées",
      to: "/verified",
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: "",
    },
  ];
}
